import { routesPaths } from './routes-paths';
import { i18n } from '../i18n';
import { IRoutePath } from '../types';

export const breadcrumbPaths: IRoutePath[] = [
  { path: routesPaths.CREATE_ACCOUNT_EXTENDED, name: i18n.t('common.create-account') },
  // TODO: remove the commented line once verified that it is safe
  // { path: routesPaths.CREATE_ACCOUNT_BASE, name: i18n.t('common.create-account') },
  { path: routesPaths.BUILD_PLAN, name: i18n.t('common.build-plan') },
  { path: routesPaths.CHECKOUT, name: i18n.t('common.checkout') },
];
